import { API_BASE } from './apiBase';
import { duelPlayerId } from './duelInbox';

// "Request a topic": suggestions, requests/votes, and the "your topic is live"
// banner. See server/src/topics.ts.

export interface TopicSuggestion { id: number; topic: string; votes: number; voted: boolean }
export interface TopicVoteResult { id: number; topic: string; votes: number; alreadyVoted: boolean; launched: string | null }
export interface LaunchedTopic { id: number; topic: string; category: string }

export class TopicRequestError extends Error {
  constructor(readonly status: number) {
    super(`topic request ${status}`);
  }
}

const post = async <T>(path: string, body: unknown): Promise<T> => {
  const res = await fetch(`${API_BASE}${path}`, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body) });
  if (!res.ok) throw new TopicRequestError(res.status);
  return (res.status === 204 ? undefined : await res.json()) as T;
};

export async function fetchPopularTopics(q = ''): Promise<TopicSuggestion[]> {
  const res = await fetch(`${API_BASE}/api/topics/popular?player=${encodeURIComponent(duelPlayerId())}&q=${encodeURIComponent(q)}`);
  if (!res.ok) throw new TopicRequestError(res.status);
  return (await res.json() as { topics: TopicSuggestion[] }).topics;
}

export const requestTopic = (topic: string) => post<TopicVoteResult>('/api/topics/request', { topic, playerId: duelPlayerId() });
export const voteForTopic = (requestId: number) => post<TopicVoteResult>('/api/topics/vote', { requestId, playerId: duelPlayerId() });

export async function fetchLaunchedTopics(): Promise<LaunchedTopic[]> {
  const player = localStorage.getItem('bf_player_id');
  if (!player) return [];
  const res = await fetch(`${API_BASE}/api/topics/launched?player=${encodeURIComponent(player)}`);
  if (!res.ok) return [];
  return (await res.json() as { launched: LaunchedTopic[] }).launched;
}

export const markLaunchedSeen = () => post<void>('/api/topics/launched/seen', { playerId: duelPlayerId() });

// The "coming soon" tiles: how many players asked for each (keyed by the topic's request key).
export type UpcomingVotes = Record<string, { votes: number; voted: boolean }>;
export async function fetchUpcomingVotes(): Promise<UpcomingVotes> {
  const res = await fetch(`${API_BASE}/api/topics/upcoming?player=${encodeURIComponent(duelPlayerId())}`);
  if (!res.ok) throw new TopicRequestError(res.status);
  return (await res.json() as { votes: UpcomingVotes }).votes;
}
